import React from "react";
import { Spin, Result, Button, Layout, Typography, Space, Avatar } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useAuth } from "../contexts/AuthContext";
import FormSelector from "./FormSelector";
import "./Taskpane.css";

const { Header, Content } = Layout;
const { Text } = Typography;

// Reusable centered wrapper
const Centered = ({ children }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100%",
    }}
  >
    {children}
  </div>
);

const Taskpane = () => {
  const { user, token, loading, error, login, logout } = useAuth();

  if (loading) {
    return (
      <Centered>
        <Spin tip="Loading authentication..." size="small" />
      </Centered>
    );
  }

  if (error) {
    return (
      <Centered>
        <Result
          status="error"
          title="Authentication failed"
          subTitle={error}
          extra={
            <Button type="primary" onClick={login}>
              Retry Login
            </Button>
          }
        />
      </Centered>
    );
  }

  if (!user || !token) {
    return (
      <Centered>
        <Result
          status="info"
          title="Please sign in to continue"
          extra={
            <Button type="primary" onClick={login}>
              Sign in
            </Button>
          }
        />
      </Centered>
    );
  }

  return (
    <div>
      {/* Top Header with user info and logout */}
      <Header
        style={{
          background: "transparent",
          padding: "0 16px",
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          borderBottom: "1px solid #f0f0f0",
          height: "1.25rem",
        }}
      >
        <Space>
          <Avatar size={12} icon={<UserOutlined style={{ color: "#426bba" }} />} />
          <Text
            style={{
              fontSize: "10px",
              color: "#426bba",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user?.username || user?.name || "User"}
          </Text>
          <LogoutOutlined
            onClick={logout}
            style={{ fontSize: "0.75rem", cursor: "pointer", color: "red" }}
            title="Logout"
          />
        </Space>
      </Header>

      {/* Main content */}
      {/* <Content style={{ padding: 16, overflow: "auto" }}> */}
      <FormSelector />
      {/* </Content> */}
    </div>
  );
};

export default Taskpane;
